// extracted by mini-css-extract-plugin
module.exports = {"content":"MainContentProfile_content__2LYJ5","postRow":"MainContentProfile_postRow__yJp7f"};